module.exports = __webpack_public_path__ + "static/media/speaker_head_expressions_face_left.312767f5.png";